import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import frLocale from "date-fns/locale/fr";
import useAuthz from 'hooks/useAuthz';
import _ from 'lodash';
import React from 'react';
import {positions, Provider as AlertProvider, transitions} from 'react-alert';
import {BrowserRouter, Link, Route, Routes} from 'react-router-dom';
import routes from 'routes';
import AlertTemplate from './components/Layout/AlertTemplate';
import Layout from './components/Layout/Layout';
import Accueil from './views/Accueil/Accueil';
import Connexion from './views/Authentification/Connexion';
import Deconnexion from './views/Authentification/Deconnexion';
import Inscription from './views/Authentification/Inscription';
import {ALERT_DURATION} from "./utils/globalConfig";
import ForgottenPassword from "./views/Authentification/ForgottenPassword";


const options = {
  position: positions.BOTTOM_CENTER,
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 9999,
  },
};

const App = () => {
  const [authz] = useAuthz();

  if (authz !== null) {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
        <AlertProvider template={AlertTemplate} {...options} timeout={Number(ALERT_DURATION)}>
          <BrowserRouter>
            <Routes>
              <Route path='/connexion' element={<Connexion/>}/>
              <Route path='/deconnexion' element={<Deconnexion/>}/>
              <Route path='/inscription' element={<Inscription/>}/>
              <Route path='/mot-de-passe-oublie' element={<ForgottenPassword/>}/>

              <Route path='/' element={authz ? <Layout component={Accueil} route='/'/> : <Connexion/>}/>
              {_.map(routes, (route, key) => {
                const {component, path, params} = route;
                return <Route path={path} key={key} element={authz ?
                  <Layout component={component} route={route} params={params}/> : <Connexion/>}/>;
              })}
              ;
              <Route
                path='*'
                element={
                  <Layout
                    component={() => (
                      <div className='row' style={{alignItems: 'center', height: '100%'}}>
                        <p className='error-page'>404.. La page demandée n'existe pas! Ooooops</p>
                        <Link type="button" className="classic-button" to={"/"}>Retour à l'accueil</Link>
                      </div>
                    )}
                  />
                }
              />
            </Routes>
          </BrowserRouter>
        </AlertProvider>
      </LocalizationProvider>
    );
  }

  return <div></div>;
};

export default App;
